import { nameOfClass } from '@tencent/workbench-core';
import { ActionPointRunner } from './action-point-runner.js';

class ActionPointRunnerBuilder {
    constructor(actionPoint, point, middlewares) {
        this.actionPoint = actionPoint;
        this.point = point;
        this.middlewares = middlewares;
    }
    buildActionPointRunner() {
        var _a;
        const customMeta = (_a = this.actionPoint.get(`${nameOfClass(this.point.from)}.${this.point.trigger}`)) === null || _a === void 0 ? void 0 : _a[this.point.name];
        const runner = new ActionPointRunner(this.middlewares, this.point, customMeta);
        runner.debug = this.actionPoint.get('debug');
        runner.hasRaw = true;
        return runner;
    }
}

export { ActionPointRunnerBuilder };
//# sourceMappingURL=action-point-runner-builder.js.map
